import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var BoxTissue = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 512 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m383.88 287.82 64-192H338.47a70.2 70.2 0 0 1-66.59-48 70.21 70.21 0 0 0-66.6-48H63.88l64 288zm-384 192a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32v-64h-512zm480-256h-40.94l-21.33 64h14.27a16 16 0 0 1 0 32h-352a16 16 0 1 1 0-32h15.21l-14.22-64h-49a32 32 0 0 0-32 32v128h512v-128a32 32 0 0 0-31.99-32z"
  }));
});
BoxTissue.displayName = 'BoxTissue';
export var BoxTissueDimensions = {
  height: 512,
  width: 512
};